import React from 'react'
import { useRosterState } from 'amazon-chime-sdk-component-library-react'
import { useTranslation } from 'react-i18next'

import { styled, SxProps } from '@mui/material/styles'
import Badge, { BadgeProps } from '@mui/material/Badge'
import Button from '@mui/material/Button'
import Tooltip from '@mui/material/Tooltip'
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined'

import ControlBarItem from './ControlBarItem'

import colors from '@/assets/scss/_themes-vars.module.scss'
import _ from 'lodash'

type AttendeeControlProps = {
  sx?: SxProps
}

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: 0,
    top: 4,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 4px',
  },
}))

export default function AttendeeControl(props: AttendeeControlProps) {
  const { sx } = props
  const { t } = useTranslation()
  const { roster } = useRosterState()
  const attendees = Object.values(roster)
  const uniqueAttendees = _.uniqBy(attendees, (attendee) => attendee?.externalUserId?.split('-')[0])

  return (
    <ControlBarItem disableMargin>
      <Tooltip title={<span>{t('component.chimeSDK.attendeeControl.attendeeButton.tooltip')}</span>} arrow>
        <Button variant="neutral" sx={sx}>
          <StyledBadge badgeContent={uniqueAttendees.length} color="primary">
            <AccountCircleOutlinedIcon htmlColor={colors.gray500} />
          </StyledBadge>
        </Button>
      </Tooltip>
    </ControlBarItem>
  )
}
